import React, { Component, createRef } from 'react'
import { inject, observer } from 'mobx-react'
import { Modal, Button, Typography, Row } from 'antd'
const { Paragraph } = Typography
import { infoMsg } from '@services/api'
import helper from '@pages/InfoMsg/helper'

@inject((store: any) => {
    const { popupStore } = store
    return { popupStore }
})
@observer
export default class EditSiteContentPopup extends Component<any, any> {
    constructor(props) {
        super(props)
        this.state = {
            dynamics: [],
            phone: '',
            isAllowSave: false,
            value: ''
        }
        this.popTypeRef = createRef('')
        this.handleSend = this.handleSend.bind(this)
        this.closePopup = this.closePopup.bind(this)
        this.handleSave = this.handleSave.bind(this)
    }

    handleSend() {
        const { dynamics, phone } = this.state
        let msg = ''
        this.state.value
            .split('$')
            .join('$$$')
            .split('$$')
            .map(str => {
                msg +=
                    [...str][0] == '$' && [...str][1] != 'n'
                        ? `${dynamics.find(d => d.key == [...str][1]).val} ${[...str].slice(2).join('')}`
                        : str
            })
        infoMsg
            .fakeSms({ msg, phone })
            .then(res => {
                alert('סמס נשלח')
                this.setState({ isAllowSave: true })
            })
            .catch(err => {
                console.log(err)
                alert('בעיית שרת, סמס לא נשלח')
            })
    }

    handleSave() {
        const {
            popupStore: {
                info: { id, key, handleSetData }
            }
        } = this.props
        infoMsg.updateContent({ id, key, value: this.state.value }).then(res => {
            handleSetData(res.data)
            alert('ערך שונה בהצלחה')
            this.closePopup()
        })
    }

    closePopup() {
        this.props.popupStore.togglePopup(false)
        this.popTypeRef.current = ''
        this.setState({ dynamics: [], phone: '' })
    }

    componentDidUpdate() {
        let {
            popupType,
            info: { value }
        } = this.props.popupStore

        if (popupType == 'fakeSms' && popupType != this.popTypeRef.current) {
            this.popTypeRef.current = popupType
            this.setState({
                value,
                dynamics: value
                    .split('$')

                    .filter((str, idx) => [...str][0] != 'n' && !!idx)
                    .map(str => {
                        return { key: [...str][0], value: '' }
                    })
            })
        } else if (popupType !== 'fakeSms' && this.state.isAllowSave) this.setState({ isAllowSave: false })
    }

    render() {
        const { dynamics, phone, isAllowSave, value } = this.state
        const { popupType, info } = this.props.popupStore
        const footerButtons = (
            <div
                style={{
                    display: 'flex',
                    width: '100%',
                    justifyContent: 'center'
                }}
            >
                <Button onClick={this.closePopup}>סגור</Button>
                <Button type="primary" onClick={this.handleSend} disabled={isAllowSave}>
                    שלח
                </Button>
                <Button type="primary" onClick={this.handleSave} disabled={!isAllowSave}>
                    שמור
                </Button>
            </div>
        )
        return (
            <Modal
                title={'דימוי שליחת סמס'}
                visible={popupType === 'fakeSms'}
                cancelText="ביטול"
                onCancel={this.closePopup}
                footer={footerButtons}
                width={1200}
            >
                <div
                    style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        flexDirection: 'column',
                        flex: 1,
                        alignItems: 'center'
                    }}
                >
                    <Row
                        gutter={28}
                        style={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            width: '100%',
                            marginTop: '1.5rem',
                            marginBottom: '1.5rem',
                            alignItems: 'center'
                        }}
                    >
                        <span style={{ fontWeight: 800, fontSize: '1rem' }}>מקרא:</span>
                        <span style={{ color: 'blue' }}>"$" = טקסט דינמי, לא לשנות אות צמודה...</span>
                        <span style={{ color: 'red' }}>"$n " = אנטר (עם הרווח אחרי)</span>
                    </Row>
                    <Paragraph
                        style={{ width: '70%', display: 'flex', justifyContent: 'center', marginBottom: '1.5rem' }}
                        editable={{
                            onChange: value => {
                                this.setState({ value, isAllowSave: false })
                            }
                        }}
                    >
                        {value}
                    </Paragraph>
                    {dynamics.map((d, idx) => (
                        <span key={idx}>
                            {`${(helper.SMS.keys[info.key] &&
                                helper.SMS.keys[info.key] &&
                                `${helper.SMS.keys[info.key].dynamics[`$${d.key}`]} - (${d.key})`) ||
                                d.key} - `}
                            <input
                                value={d.value}
                                onChange={e =>
                                    this.setState({
                                        dynamics: [...dynamics].map((ds, index) =>
                                            idx == index
                                                ? {
                                                      key: ds.key,
                                                      val: e.target.value
                                                  }
                                                : ds
                                        )
                                    })
                                }
                            />
                        </span>
                    ))}
                    <div style={{ display: 'flex', flexDirection: 'row', marginBottom: '1.5rem' }}>
                        טלפון -
                        <span style={{ marginRight: '0.4rem' }}>
                            <input
                                style={{ width: 100 }}
                                value={phone}
                                onChange={e => this.setState({ phone: e.target.value })}
                            />
                            {` 0`}
                        </span>
                    </div>
                </div>
            </Modal>
        )
    }
}
